import {DELIVERY} from "../../../../constants";

export default {
    state: {
        address2: 'с 10:00 до 13:00',
        deliveryStreet: '',
        deliveryBlock: '',
        deliveryApartment: '',
        deliveryTimes: [
            'с 10:00 до 13:00',
            'с 13:00 до 18:00'
        ],
        delivery_list: {
            [DELIVERY.PICKUP]: {
                id: 1,
                cost: 'Бесплатно',
                type: DELIVERY.PICKUP,
                title: 'Самовывоз из магазина СТОМАЛЮКС',
                description: 'Магазин работает с 9:00 до 18:00'
            },
            [DELIVERY.COURIER]: {
                id: 2,
                cost: 2000,
                type: DELIVERY.COURIER,
                title: 'Доставка курьером по Самаре*, Тольятти, Димитровграду и Ульяновску',
                description: 'Доставка с 10:00 до 18:00',
            },
            [DELIVERY.POST]: {
                id: 3,
                cost: 'За Ваш счет',
                type: DELIVERY.POST,
                title: 'Доставка почтой или другой транспортной компанией',
                description: 'Отправим завтра'
            },
        },
        selectedDelivery: {
            id: 1,
            cost: 'Бесплатно',
            type: DELIVERY.PICKUP,
            title: 'Самовывоз из магазина СТОМАЛЮКС',
            description: 'Магазин работает с 9:00 до 18:00'
        },
    },

    getters: {
        getDeliveryAddress2: (state) => state.address2,
        getDeliveryList: (state) => state.delivery_list,
        getDeliveryTimes(state) {
            return state.deliveryTimes
        },
        getDeliveryCost(state) {
            if(state.selectedDelivery.type === DELIVERY.COURIER)
                return `${state.selectedDelivery.cost} руб.`
            else return state.selectedDelivery.cost
        },
        getOrderDeliveryDetails(state, getters, rootState) {
            // console.log(rootState.locations)
            // return ''
            return {
                city_id: rootState.locations.selectedCity.id,
                country_id: rootState.locations.selectedCity.country.id,
                address1: concateAddress1(state, rootState),
                address2: state.address2,
            }
        },
        getSelectedDelivery(state) {
            return state.selectedDelivery
        },
        isCourierDeliverySelected(state) {
            return state.selectedDelivery.type === DELIVERY.COURIER
        },
        isPostDeliverySelected(state) {
            return state.selectedDelivery.type === DELIVERY.POST
        },
        isAddress1Complete(state) {
            return  !!state.deliveryBlock &&
                !!state.deliveryStreet &&
                !!state.deliveryApartment
        },
    },
    mutations: {
        setCourierDeliveryDetails(state, val) {
            state.courier_delivery_details = val
        },
        setPostDeliveryDetails(state, val) {
            state.post_delivery_details = val
        },
        setSelectedDelivery(state, type) {
            state.selectedDelivery = state.delivery_list[type]
        },
        setDeliveryApartment(state, payload) {
            state.deliveryApartment = payload
        },
        setDeliveryBlock(state, payload) {
            state.deliveryBlock = payload
        },
        setDeliveryStreet(state, payload) {
            state.deliveryStreet = payload
        },
        setDeliveryAddress2(state, payload) {
            state.address2 = payload
        }
    }
}

function concateAddress1(state, rootState) {
    return `г.${getCityTitle(rootState)} ул.${state.deliveryStreet} дом ${state.deliveryBlock} ${state.deliveryApartment? 'кв.' + state.deliveryApartment : ''}`
}

function getCityTitle(rootState) {
    if(rootState.locations?.selectedCity?.id !== 1) return rootState.locations?.selectedCity?.title
    return rootState.locations?.otherCity
}
